import { defineStore } from 'pinia'
import { useCartStore } from './cart'

// const {$showToast} = useNuxtApp();
export const useWishlistStore = defineStore('wishlist', {

    state: () => (
        {
            data: []
        }
    ),
    persist: true,

    getters: {
        wishlist: state => state.data,
        wishlistQty (state) {
            return state.data.length;
        },
        isInWishlist: (state) => (product) => {
            return state.data.find( item => item.id == product.id ) ? true : false
        }
    },

    actions: {
        addToWishlist (payload) {
            var findIndex = this.data.findIndex( item => item.id === payload.product.id );
            if ( findIndex == -1 ) {
                this.data = [
                    ...this.data,
                    payload.product
                ];
            }

            const { $showToast } = useNuxtApp()
            $showToast("Product added to wishlist", "success", 1500);
        },

        removeItem (payload) {
            this.data = this.data.filter( item => item.id !== payload.product.id );
        },

        removeFromWishlist (payload) {
            this.removeItem(payload);
            const { $showToast } = useNuxtApp()
            $showToast("Product removed from wishlist", "info", 1500);

        },
        moveToCart (payload) {
            this.removeItem(payload);
            // this.commit( 'cart/ADD_TO_CART', { product: payload.product, qty: 1 } );
            cartStore.addToCart(payload.product, 1 );
            const { $showToast } = useNuxtApp()
            $showToast("Product moved to cart", "success", 1500);
        }
    }

})